import { PaymentService } from '@app/_services/payment.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonUtility } from '@app/_modules/commonUtility';
import { environment } from '@environments/environment';


@Component({ templateUrl: 'student-details.component.html' })
export class StudentDetailComponent implements OnInit {

  @ViewChild('txnForm') txnForm: any;
    isgPay_url:any;
    EncDataField:string;
    MerchantIdField:string;
    TransactionId:string;
    BankIdField:string;
    TerminalIdField:string;
    VersionField:string;
    isRecordNotFound:boolean = false;
    form: FormGroup;
    tranxnForm : FormGroup;
    loading = false;
    submitted = false;
    registeras;
    res:any;
    billDate:any='';
    feeData:any;
    dueDate:any
    studentData:any;
    commonUtility:CommonUtility;
    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private paymentService: PaymentService
    ) {
      this.isgPay_url = paymentService.isgPay_url;
      this.res=this.router.getCurrentNavigation().extras.state

      if(this.router.getCurrentNavigation().extras.state === null || this.router.getCurrentNavigation().extras.state === undefined)
      {
        this.router.navigate(['/payment/get-student']);
      }
     if(!(this.res.message === "No Payment Found"))
     {
      this.studentData = this.res.studentData;
      this.feeData = this.res.feeData;
   /*    this.billDate = this.res.billDate */
      this.dueDate = this.res.dueDate
      this.commonUtility = paymentService.commonUtility;
     }
     else
     {
      this.isRecordNotFound = true;
     }
    }

    ngOnInit() {
        this.registeras =1;
        this.form = this.formBuilder.group({
            emailId : ['', [Validators.required,Validators.pattern("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$")]],
           mobileNo : ['', [Validators.required,Validators.pattern("^[0-9]*$"), Validators.minLength(10),Validators.maxLength(10)]],
        });
        this.tranxnForm = this.formBuilder.group({
          Version:[''],
          TerminalId: [''],
          BankId: [''],
          MerchantId: [''],
          EncData:[''],
          TransactionId:['']

               });
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }
    redirectHome()
    {
      this.router.navigate(['/']);
    }
    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        // this.alertService.clear();
        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }
        this.loading = true;

        var req={
            "studentId":this.studentData.studentId.toString(),
            "emailId":this.form.controls.emailId.value,
            "mobileNo":this.form.controls.mobileNo.value.toString(),
            "registrationNo" :  this.studentData.registrationNo.toString(),
            "status" : this.feeData.status.toString()
        }

        this.paymentService.updateStudentDetail(req).subscribe(res=>{

      //console.log("res "+JSON.stringify(res));
       if(res.body.statusCode === "00000")
       {
        //console.log(" res : "+JSON.stringify(res))
        //this.commonUtility.alertMsg('Submitted Successfully ','',true);
        this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
        this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
        this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
        this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
        this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
        this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);

        this.EncDataField  	= res.body.data.fields.EncData;
        this.MerchantIdField = res.body.data.fields.MerchantId;
        this.BankIdField = res.body.data.fields.BankId;
        this.TerminalIdField = res.body.data.fields.TerminalId ;
        this.VersionField = res.body.data.fields.Version ;
        this.txnForm.nativeElement.submit();


       }
       else{
        this.commonUtility.alertMsg('Please try again Failed to submit data'+res.body.statusDesc,'',false);
       }
        this.loading = false;
      },
      (error)=>{

        this.commonUtility.alertMsg('Please try again Failed to submit data','',false);
          //this.router.navigate([''])
          this.loading = false;
        });

    }

    showForm (ele){
        this.registeras =ele;
    }
    checkZero(value)
    {
      var a:number=Number(value);

      if(Number.isNaN(a) || a == null || a === Number(0) || a === undefined || value === null || value === undefined)
      {
        return false;
      }
      return true;
    }

}
